import { createAsyncReducer } from '@telstra-connect/standard-actions';
import {
    ILoadInvoiceDetailNewAction,
    ILoadInvoiceDetailNewSuccessAction,
    LoadInvoiceDetailNewErrorAction
} from '../actions/load-invoice-details-new';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadInvoiceDetailNewAction
    = ILoadInvoiceDetailNewAction
    | ILoadInvoiceDetailNewSuccessAction
    | LoadInvoiceDetailNewErrorAction;

const init = (state: IBillingState, action: LoadInvoiceDetailNewAction) => ({
    ...state,
    invoiceDetailNew: {
        ...state.invoiceDetailNew,
        status: action.status
    }
});

const success = (state: IBillingState, action: LoadInvoiceDetailNewAction) => ({
    ...state,
    invoiceDetailNew: {
        status: action.status,
        data: (action as ILoadInvoiceDetailNewSuccessAction).data
    }
});

const failure = (state: IBillingState, action: LoadInvoiceDetailNewAction) => ({
    ...state,
    invoiceDetailNew: {
        ...initialState.invoiceDetailNew,
        status: action.status,
        error: (action as LoadInvoiceDetailNewErrorAction).error,
        errorCode: (action as LoadInvoiceDetailNewErrorAction).errorCode

    }
});

export const loadInvoiceDetailNewReducer = createAsyncReducer(initialState, init, success, failure);
